import axios from 'axios';

export const TEAM_PRODUCTS_CREATED = 'TEAM_PRODUCTS_CREATED';

const createTeamProducts = (teamId, productData) => (
    dispatch => (
        axios.post(`/api/teams/${teamId}/create-product`, productData)
          .then((response) => {
            if (response.status === 200) {
                dispatch({
                    type: TEAM_PRODUCTS_CREATED,
                    teamId,
                    products: response.data.data,
                });
            }

            return response;
        }).catch((error) => {
            if (error.response && error.response.status === 401) {
                window.location = '/login';
            }
        })
    )
);

export default createTeamProducts;
